module.exports = __webpack_public_path__ + "img/online-chat.af2581db.svg";